/**
 * Format a duration given in minutes into a human-readable string.
 *
 * Examples: 0→'0m', 45→'45m', 60→'1h 0m', 90→'1h 30m', 1440→'24h 0m'
 */
export function formatDuration(minutes: number): string {
  if (minutes < 0) return "0m";

  const hrs = Math.floor(minutes / 60);
  const mins = minutes - hrs * 60;
  // Preserve 1 decimal place for fractional minutes (e.g., avgDurationPerItem)
  const formattedMins = mins % 1 !== 0 ? Number(mins.toFixed(1)).toString() : String(Math.round(mins));

  if (hrs === 0) return `${formattedMins}m`;
  return `${hrs}h ${formattedMins}m`;
}
